(function () {
  const WARNING = {
    title: 'Renk Stokları Hakkında',
    text:
      '*Renk stokları anlık değişmektedir.*\n\n' +
      'İstediğiniz renk stokta yoksa size ulaşıp mevcut renkleri söylüyoruz.\n\n' +
      'Lütfen "bu renk var mı, o renk var mı" diye sormayınız. İstediğiniz rengi işaretleyerek sipariş veriniz.\n\n' +
      'Farklı bir durum olursa size yazıyoruz.',
    cancel: 'Vazgeç',
    ok: 'Anladım, Sepete Ekle'
  };

  const COLOR_SWATCH_SELECTOR =
    'variant-picker .opt-label--swatch, ' +
    'variant-picker .js-color-text, ' +
    'variant-picker [data-swatch], ' +
    '.card__swatches .opt-label--swatch, ' +
    '.card__swatches [data-swatch], ' +
    '.product-options .opt-label--swatch, ' +
    '.product-options [data-swatch]';

  const productCache = new Map();
  let lastAtcContext = null;

  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest('[name="add"], button.js-quick-add');
      if (!btn) return;
      lastAtcContext = btn.closest(
        'quick-add-drawer, product-card, .cc-main-product, product-form, .js-product'
      );
    },
    true
  );

  function getColorOptionNames() {
    if (window.theme?.settings?.swatchOptionNames) {
      return window.theme.settings.swatchOptionNames
        .map((name) => name.trim().toLowerCase())
        .filter(Boolean);
    }
    return ['renk', 'color', 'colour', 'couleur', 'farbe'];
  }

  function getOpenQuickAddDrawer() {
    return (
      document.querySelector('quick-add-drawer[open]') ||
      document.querySelector('quick-add-drawer[aria-hidden="false"]')
    );
  }

  function contextHasColorOption(context) {
    if (!context) return false;
    return !!context.querySelector(COLOR_SWATCH_SELECTOR);
  }

  function getProductHandle(form) {
    const contexts = [
      form,
      form?.closest('.js-product, product-card, quick-add-drawer, .cc-main-product'),
      lastAtcContext,
      getOpenQuickAddDrawer()
    ].filter(Boolean);

    for (const context of contexts) {
      const link = context.querySelector('.js-prod-link, .js-quick-add');
      const url = link?.href || link?.dataset?.productUrl;
      if (url) {
        const match = url.match(/\/products\/([^/?#]+)/);
        if (match) return match[1];
      }
    }

    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  async function productHasColorOption(handle) {
    if (!handle) return false;

    let product = productCache.get(handle);
    if (!product) {
      try {
        const res = await fetch('/products/' + handle + '.js', { cache: 'no-store' });
        if (!res.ok) return false;
        product = await res.json();
        productCache.set(handle, product);
      } catch {
        return false;
      }
    }

    const colorNames = getColorOptionNames();
    return (product.options || []).some((option) => colorNames.includes(String(option).toLowerCase()));
  }

  function domHasColorOption(form) {
    const contexts = [
      form,
      form?.closest('.js-product, product-card, quick-add-drawer, .cc-main-product'),
      lastAtcContext,
      getOpenQuickAddDrawer()
    ].filter(Boolean);

    return contexts.some(contextHasColorOption);
  }

  async function shouldWarn(form) {
    if (domHasColorOption(form)) return true;
    const handle = getProductHandle(form);
    return productHasColorOption(handle);
  }

  function ensureModalStyles() {
    if (document.getElementById('tm-renk-stok-style')) return;

    const style = document.createElement('style');
    style.id = 'tm-renk-stok-style';
    style.textContent = `
      .tm-renk-stok-overlay{
        position:fixed; inset:0; background:rgba(0,0,0,.55);
        display:flex; align-items:center; justify-content:center;
        z-index:10000001;
        padding:16px;
      }
      .tm-renk-stok-modal{
        width:min(560px, 100%);
        background:#fff;
        border-radius:16px;
        box-shadow:0 20px 60px rgba(0,0,0,.25);
        overflow:hidden;
        font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial;
      }
      .tm-renk-stok-head{
        padding:16px 18px;
        border-bottom:1px solid rgba(0,0,0,.08);
        font-weight:800;
        font-size:16px;
      }
      .tm-renk-stok-body{
        padding:16px 18px;
        line-height:1.55;
        white-space:pre-line;
        color:#111;
        font-size:14px;
      }
      .tm-renk-stok-body b{ font-weight:800; }
      .tm-renk-stok-actions{
        padding:14px 18px 18px;
        display:flex;
        gap:10px;
        justify-content:flex-end;
        flex-wrap:wrap;
      }
      .tm-renk-stok-btn{
        border-radius:12px;
        padding:10px 14px;
        font-size:14px;
        cursor:pointer;
        border:1px solid rgba(0,0,0,.14);
        background:#fff;
      }
      .tm-renk-stok-btn-primary{
        border-color:transparent;
        background:#ff580d;
        color:#fff;
      }
      .tm-renk-stok-btn:active{ transform:translateY(1px); }
    `;
    document.head.appendChild(style);
  }

  function escapeHtml(str) {
    return (str || '').replace(/[&<>"']/g, (m) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    }[m]));
  }

  function formatTextToHTML(text) {
    return escapeHtml(text).replace(/\*(.+?)\*/g, '<b>$1</b>');
  }

  let modalOpen = false;

  function showRenkStokModal() {
    if (modalOpen) return Promise.resolve(false);
    modalOpen = true;
    ensureModalStyles();

    return new Promise((resolve) => {
      const overlay = document.createElement('div');
      overlay.className = 'tm-renk-stok-overlay';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');

      const modal = document.createElement('div');
      modal.className = 'tm-renk-stok-modal';
      modal.innerHTML =
        '<div class="tm-renk-stok-head">' + escapeHtml(WARNING.title) + '</div>' +
        '<div class="tm-renk-stok-body">' + formatTextToHTML(WARNING.text) + '</div>' +
        '<div class="tm-renk-stok-actions">' +
          '<button type="button" class="tm-renk-stok-btn tm-renk-stok-btn-cancel">' + escapeHtml(WARNING.cancel) + '</button>' +
          '<button type="button" class="tm-renk-stok-btn tm-renk-stok-btn-primary tm-renk-stok-btn-ok">' + escapeHtml(WARNING.ok) + '</button>' +
        '</div>';

      overlay.appendChild(modal);
      document.body.appendChild(overlay);

      const close = (val) => {
        modalOpen = false;
        overlay.remove();
        resolve(val);
      };

      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) close(false);
      });

      function onKey(e) {
        if (e.key === 'Escape') {
          document.removeEventListener('keydown', onKey);
          close(false);
        }
      }
      document.addEventListener('keydown', onKey);

      overlay.querySelector('.tm-renk-stok-btn-cancel').addEventListener('click', () => {
        document.removeEventListener('keydown', onKey);
        close(false);
      });
      overlay.querySelector('.tm-renk-stok-btn-ok').addEventListener('click', () => {
        document.removeEventListener('keydown', onKey);
        close(true);
      });
    });
  }

  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      if (!form?.classList?.contains('js-product-form')) return;
      if (form.id === 'product-signup_form') return;

      if (form.dataset.tmRenkStokConfirmed === 'true') {
        delete form.dataset.tmRenkStokConfirmed;
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      (async () => {
        const needsWarn = await shouldWarn(form);
        if (!needsWarn) {
          form.dataset.tmRenkStokConfirmed = 'true';
          form.requestSubmit();
          return;
        }

        const ok = await showRenkStokModal();
        if (!ok) return;

        form.dataset.tmRenkStokConfirmed = 'true';
        form.requestSubmit();
      })();
    },
    true
  );
})();
